import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router';
import store from './store';




Vue.config.productionTip = false
//全局引入
Vue.use(ElementUI);

//登录验证
// router.beforeEach((to,from,next)=>{
//   const token=cookie.get('token')
//   if(!token&&to.name!=='login'){
//     next({name:'login'})
//   }else if(token&&to.name==='login'){
//     next({name:'home'})
//   }else{
//     next()
//   }
// })

new Vue({
  router,store,
  render: h => h(App),
}).$mount('#app')
